/**
 * Toggles classes on .main-nav__child elements inside .js-mega-nav <details>
 * disclosures so CSS can render a bottom-fade scroll affordance.
 *
 * Classes:
 *   has-scroll-overflow  — content exceeds the visible area
 *   is-scrolled-bottom   — user has scrolled to (within 4px of) the bottom
 *
 * The cue only matters on desktop where .main-nav__child is a bounded
 * floating panel. Below 769px the menu becomes a full-screen sheet and the
 * classes do nothing (no CSS rule targets them at that breakpoint).
 */
(function () {
  const SCROLL_TOLERANCE_PX = 4;
  const DESKTOP_MIN_WIDTH = 769;

  function isDesktop() {
    return window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`).matches;
  }

  function evaluateOverflow(panel) {
    if (!isDesktop()) {
      panel.classList.remove('has-scroll-overflow', 'is-scrolled-bottom');
      return;
    }
    const overflows = panel.scrollHeight > panel.clientHeight + 1;
    panel.classList.toggle('has-scroll-overflow', overflows);
    if (!overflows) {
      panel.classList.remove('is-scrolled-bottom');
      return;
    }
    const atBottom =
      panel.scrollTop + panel.clientHeight >= panel.scrollHeight - SCROLL_TOLERANCE_PX;
    panel.classList.toggle('is-scrolled-bottom', atBottom);
  }

  function reset(panel) {
    panel.classList.remove('has-scroll-overflow', 'is-scrolled-bottom');
    panel.scrollTop = 0;
  }

  function init() {
    const disclosures = document.querySelectorAll('details.js-mega-nav');
    disclosures.forEach((disclosure) => {
      const panel = disclosure.querySelector('.main-nav__child');
      if (!panel) return;

      panel.addEventListener('scroll', () => evaluateOverflow(panel), { passive: true });

      const resizeObserver = new ResizeObserver(() => evaluateOverflow(panel));
      resizeObserver.observe(panel);

      const classObserver = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type !== 'attributes' || m.attributeName !== 'class') continue;
          if (disclosure.classList.contains('is-open')) {
            requestAnimationFrame(() => evaluateOverflow(panel));
          } else {
            reset(panel);
          }
        }
      });
      classObserver.observe(disclosure, { attributes: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();